import React from 'react'
import classNames from 'classnames'
import { Helmet } from "react-helmet" ;
const TableCard = ({ ratethe, type, setType, saleRate, userOption, bangsale, lever, setSaleRate, setLever }) => {
    return (
        <div>
            {userOption === 'boardPrice' && (
                <>
                  <Helmet>
        <title>Bảng Giá Chiết Khấu Đổi Thẻ Cào</title>
        <meta name="description" content="Xem bảng giá chiết khấu đổi thẻ cào thành tiền mặt. Hỗ trợ đổi thẻ cào nhanh chóng, chiết khấu cực thấp, không qua trung gian. Đổi thẻ cào game thành tiền mặt uy tín, tiện lợi." />
        <meta name="keywords" content="bảng giá chiết khấu đổi thẻ cào, đổi thẻ cào thành tiền mặt, đổi thẻ cào game, đổi thẻ cào, đổi thẻ game, chiết khấu đổi thẻ cào" />
        <meta name="author" content="ĐỔI THẺ CÀO THÀNH TIỀN MẶT" />

        <meta property="og:title" content="Bảng Giá Chiết Khấu Đổi Thẻ Cào" />
        <meta property="og:site_name" content="ĐỔI THẺ CÀO THÀNH TIỀN MẶT" />
        <meta property="og:url" content="https://hust.media" />
        <meta property="og:description" content="Xem bảng giá chiết khấu đổi thẻ cào thành tiền mặt. Hỗ trợ đổi thẻ cào nhanh chóng, chiết khấu cực thấp, không qua trung gian. Đổi thẻ cào game thành tiền mặt uy tín, tiện lợi." />
      </Helmet>
                    <div className='my-3 hidden lg:block'>
                        <div className='px-3 py-2 mx-auto flex-wrap bg-white rounded-sm flex gap-2 lg:max-w-xl'>
                            {bangsale &&
                                bangsale.map((item) => {
                                    return (
                                        <div
                                            className={`text-xs lg:text-base rounded-md border-2 cursor-pointer px-2 py-1 ${classNames(
                                                {
                                                    'border-blue-600': item.namelevel === lever,
                                                },
                                            )}`}
                                            onClick={() => {
                                                setLever(item.namelevel)
                                                setSaleRate(item.ratethe)
                                            }}>
                                            {item.namelevel}
                                        </div>
                                    )
                                })}
                        </div>
                    </div>
                    <div className='mt-6 hidden lg:block'>
                        <table className='text-center'>
                            <tr className='text-xs'>
                                <th className='px-2 py-1 border'>Loại thẻ</th>
                                <th className='px-2 py-1 border'>10.000 VNĐ</th>
                                <th className='px-2 py-1 border'>20.000 VNĐ</th>
                                <th className='px-2 py-1 border'>30.000 VNĐ</th>
                                <th className='px-2 py-1 border'>50.000 VNĐ</th>
                                <th className='px-2 py-1 border'>100.000 VNĐ</th>
                                <th className='px-2 py-1 border'>200.000 VNĐ</th>
                                <th className='px-2 py-1 border'>300.000 VNĐ</th>
                                <th className='px-2 py-1 border'>500.000 VNĐ</th>
                                <th className='px-2 py-1 border'>1000.000 VNĐ</th>
                                <th className='px-2 py-1 border'>2000.000 VNĐ</th>
                                <th className='px-2 py-1 border'>5000.000 VNĐ</th>
                            </tr>
                            <tr>
                                <td className='border px-2 py-1'>VIETTEL</td>
                                {ratethe &&
                                    ratethe.map((item) => {
                                        if (item.telco === 'VIETTEL')
                                            return (
                                                <td className='border px-2 py-1'>
                                                    {Math.round((item.fees / (100 + Number(saleRate))) * 100 * 100) /
                                                        100}
                                                    %
                                                </td>
                                            )
                                        return null
                                    })}
                            </tr>
                            <tr>
                                <td className='border px-2 py-1'>VINAPHONE</td>
                                {ratethe &&
                                    ratethe.map((item) => {
                                        if (item.telco === 'VINAPHONE')
                                            return (
                                                <td className='border px-2 py-1'>
                                                    {Math.round((item.fees / (100 + Number(saleRate))) * 100 * 100) /
                                                        100}
                                                    %
                                                </td>
                                            )
                                        return null
                                    })}
                            </tr>
                            <tr>
                                <td className='border px-2 py-1'>MOBIFONE</td>
                                {ratethe &&
                                    ratethe.map((item) => {
                                        if (item.telco === 'MOBIFONE')
                                            return (
                                                <td className='border px-2 py-1'>
                                                    {Math.round((item.fees / (100 + Number(saleRate))) * 100 * 100) /
                                                        100}
                                                    %
                                                </td>
                                            )
                                        return null
                                    })}
                            </tr>
                            <tr>
                                <td className='border px-2 py-1'>VNMOBI</td>
                                {ratethe &&
                                    ratethe.map((item) => {
                                        if (item.telco === 'VNMOBI')
                                            return (
                                                <td className='border px-2 py-1'>
                                                    {Math.round((item.fees / (100 + Number(saleRate))) * 100 * 100) /
                                                        100}
                                                    %
                                                </td>
                                            )
                                        return null
                                    })}
                            </tr>
                            <tr>
                                <td className='border px-2 py-1'>ZING</td>
                                {ratethe &&
                                    ratethe.map((item) => {
                                        if (item.telco === 'ZING')
                                            return (
                                                <td className='border px-2 py-1'>
                                                    {Math.round((item.fees / (100 + Number(saleRate))) * 100 * 100) /
                                                        100}
                                                    %
                                                </td>
                                            )
                                        return null
                                    })}
                            </tr>
                            <tr>
                                <td className='border px-2 py-1'>VCOIN</td>
                                {ratethe &&
                                    ratethe.map((item) => {
                                        if (item.telco === 'VCOIN')
                                            return (
                                                <td className='border px-2 py-1'>
                                                    {Math.round((item.fees / (100 + Number(saleRate))) * 100 * 100) /
                                                        100}
                                                    %
                                                </td>
                                            )
                                        return null
                                    })}
                            </tr>
                            <tr>
                                <td className='border px-2 py-1'>GARENA</td>
                                {ratethe &&
                                    ratethe.map((item) => {
                                        if (item.telco === 'GARENA')
                                            return (
                                                <td className='border px-2 py-1'>
                                                    {Math.round((item.fees / (100 + Number(saleRate))) * 100 * 100) /
                                                        100}
                                                    %
                                                </td>
                                            )
                                        return null
                                    })}
                            </tr>
                            <tr>
                                <td className='border px-2 py-1'>GATE</td>
                                {ratethe &&
                                    ratethe.map((item) => {
                                        if (item.telco === 'GATE')
                                            return (
                                                <td className='border px-2 py-1'>
                                                    {Math.round((item.fees / (100 + Number(saleRate))) * 100 * 100) /
                                                        100}
                                                    %
                                                </td>
                                            )
                                        return null
                                    })}
                            </tr>
                        </table>
                    </div>
                </>
            )}
            {userOption === 'boardPrice' && (
                <>
                    <div className='my-3 lg:hidden'>
                        <div className='px-3 py-2 mx-auto flex-wrap bg-white rounded-sm flex gap-2 lg:max-w-xl'>
                            {bangsale &&
                                bangsale.map((item) => {
                                    return (
                                        <div
                                            className={`text-xs lg:text-base rounded-md border-2 cursor-pointer px-2 py-1 ${classNames(
                                                {
                                                    'border-blue-600': item.namelevel === lever,
                                                },
                                            )}`}
                                            onClick={() => {
                                                setLever(item.namelevel)
                                                setSaleRate(item.ratethe)
                                            }}>
                                            {item.namelevel}
                                        </div>
                                    )
                                })}
                        </div>
                    </div>
                    <div className='mt-6 lg:hidden flex justify-center '>
                        <table className='text-center text-xs lg:text-base w-full'>
                            <tr>
                                <td className='border px-2 py-1'>Loại thẻ</td>
                                <td className='border px-2 py-1'>Mệnh giá</td>
                                <td className='border px-2 py-1'>Chiết khấu</td>
                            </tr>
                            <tr className='border'>
                                <td className='flex flex-col'>
                                    <td
                                        className={`inline-block rounded-t-lg border-b text-black no-underline min-h-[50px] ${classNames(
                                            { 'border-blue-600 text-blue-600': type === 'VIETTEL' },
                                        )}`}
                                        onClick={() => setType('VIETTEL')}>
                                        VIETTEL
                                    </td>
                                    <td
                                        className={`inline-block rounded-t-lg border-b text-black no-underline min-h-[50px] ${classNames(
                                            { 'border-blue-600 text-blue-600': type === 'VINAPHONE' },
                                        )}`}
                                        onClick={() => setType('VINAPHONE')}>
                                        VINAPHONE
                                    </td>
                                    <td
                                        className={`inline-block rounded-t-lg border-b text-black no-underline min-h-[50px] ${classNames(
                                            { 'border-blue-600 text-blue-600': type === 'MOBIFONE' },
                                        )}`}
                                        onClick={() => setType('MOBIFONE')}>
                                        MOBIFONE
                                    </td>
                                    <td
                                        className={`inline-block rounded-t-lg border-b text-black no-underline min-h-[50px] ${classNames(
                                            { 'border-blue-600 text-blue-600': type === 'VNMOBI' },
                                        )}`}
                                        onClick={() => setType('VNMOBI')}>
                                        VNMOBI
                                    </td>
                                    <td
                                        className={`inline-block rounded-t-lg border-b text-black no-underline min-h-[50px] ${classNames(
                                            { 'border-blue-600 text-blue-600': type === 'ZING' },
                                        )}`}
                                        onClick={() => setType('ZING')}>
                                        ZING
                                    </td>
                                    <td
                                        className={`inline-block rounded-t-lg border-b text-black no-underline min-h-[50px] ${classNames(
                                            { 'border-blue-600 text-blue-600': type === 'VCOIN' },
                                        )}`}
                                        onClick={() => setType('VCOIN')}>
                                        VCOIN
                                    </td>
                                    <td
                                        className={`inline-block rounded-t-lg border-b text-black no-underline min-h-[50px] ${classNames(
                                            { 'border-blue-600 text-blue-600': type === 'GARENA' },
                                        )}`}
                                        onClick={() => setType('GARENA')}>
                                        GARENA
                                    </td>
                                    <td
                                        className={`inline-block rounded-t-lg text-black no-underline min-h-[50px] ${classNames(
                                            { 'border-blue-600 border-b text-blue-600': type === 'GATE' },
                                        )}`}
                                        onClick={() => setType('GATE')}>
                                        GATE
                                    </td>
                                </td>
                                {type === 'VIETTEL' && (
                                    <td className='border'>
                                        <td className='border-b py-1 block text-sm md:text-base min-h-[50px]'>
                                            10.000 VNĐ
                                        </td>
                                        <td className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            20.000 VNĐ
                                        </td>
                                        <td className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            30.000 VNĐ
                                        </td>
                                        <td className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            50.000 VNĐ
                                        </td>
                                        <td className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            100.000 VNĐ
                                        </td>
                                        <td className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            200.000 VNĐ
                                        </td>
                                        <td className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            300.000 VNĐ
                                        </td>
                                        <td className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            500.000 VNĐ
                                        </td>
                                        <td className='px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            1000.000 VNĐ
                                        </td>
                                    </td>
                                )}
                                {type === 'VIETTEL' && (
                                    <td className='border'>
                                        {ratethe &&
                                            ratethe.map((item) => {
                                                if (item.telco === 'VIETTEL')
                                                    return (
                                                        <tr className='px-2 py-1 block text-sm md:texttext-sm md:text-base border-b min-h-[50px]'>
                                                            {Math.round(
                                                                (item.fees / (100 + Number(saleRate))) * 100 * 100,
                                                            ) / 100}
                                                            %
                                                        </tr>
                                                    )
                                                return null
                                            })}
                                    </td>
                                )}
                                {type === 'VINAPHONE' && (
                                    <td className='border'>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            10.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            20.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            30.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            50.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            100.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            200.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            300.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            500.000 VNĐ
                                        </tr>
                                    </td>
                                )}
                                {type === 'VINAPHONE' && (
                                    <td className='border'>
                                        {ratethe &&
                                            ratethe.map((item) => {
                                                if (item.telco === 'VINAPHONE')
                                                    return (
                                                        <tr className='text-sm md:text-base min-h-[50px] border-b px-2 py-1 block'>
                                                            {Math.round(
                                                                (item.fees / (100 + Number(saleRate))) * 100 * 100,
                                                            ) / 100}
                                                            %
                                                        </tr>
                                                    )
                                                return null
                                            })}
                                    </td>
                                )}
                                {type === 'MOBIFONE' && (
                                    <td className='border'>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            10.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            20.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            30.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            50.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            100.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            200.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            300.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            500.000 VNĐ
                                        </tr>
                                    </td>
                                )}
                                {type === 'MOBIFONE' && (
                                    <td className='border'>
                                        {ratethe &&
                                            ratethe.map((item) => {
                                                if (item.telco === 'MOBIFONE')
                                                    return (
                                                        <tr className='text-sm md:text-base min-h-[50px] border-b px-2 py-1 block'>
                                                            {Math.round(
                                                                (item.fees / (100 + Number(saleRate))) * 100 * 100,
                                                            ) / 100}
                                                            %
                                                        </tr>
                                                    )
                                                return null
                                            })}
                                    </td>
                                )}
                                {type === 'VNMOBI' && (
                                    <td className='border'>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            10.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            20.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            30.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            50.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            100.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            200.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            300.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            500.000 VNĐ
                                        </tr>
                                    </td>
                                )}
                                {type === 'VNMOBI' && (
                                    <td className='border'>
                                        {ratethe &&
                                            ratethe.map((item) => {
                                                if (item.telco === 'VNMOBI')
                                                    return (
                                                        <tr className='text-sm md:text-base min-h-[50px] border-b px-2 py-1 block'>
                                                            {Math.round(
                                                                (item.fees / (100 + Number(saleRate))) * 100 * 100,
                                                            ) / 100}
                                                            %
                                                        </tr>
                                                    )
                                                return null
                                            })}
                                    </td>
                                )}
                                {type === 'ZING' && (
                                    <td className='border'>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            10.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            20.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            30.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            50.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            100.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            200.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            300.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            500.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            1000.000 VNĐ
                                        </tr>
                                    </td>
                                )}
                                {type === 'ZING' && (
                                    <td className='border'>
                                        {ratethe &&
                                            ratethe.map((item) => {
                                                if (item.telco === 'ZING')
                                                    return (
                                                        <tr className='text-sm md:text-base min-h-[50px] border-b px-2 py-1 block'>
                                                            {Math.round(
                                                                (item.fees / (100 + Number(saleRate))) * 100 * 100,
                                                            ) / 100}
                                                            %
                                                        </tr>
                                                    )
                                                return null
                                            })}
                                    </td>
                                )}
                                {type === 'VCOIN' && (
                                    <td className='border'>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            10.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            20.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            30.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            50.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            100.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            200.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            300.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            500.000 VNĐ
                                        </tr>
                                    </td>
                                )}
                                {type === 'VCOIN' && (
                                    <td className='border'>
                                        {ratethe &&
                                            ratethe.map((item) => {
                                                if (item.telco === 'VCOIN')
                                                    return (
                                                        <tr className='text-sm md:text-base min-h-[50px] border-b px-2 py-1 block'>
                                                            {Math.round(
                                                                (item.fees / (100 + Number(saleRate))) * 100 * 100,
                                                            ) / 100}
                                                            %
                                                        </tr>
                                                    )
                                                return null
                                            })}
                                    </td>
                                )}
                                {type === 'GARENA' && (
                                    <td className='border '>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            10.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            20.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            30.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            50.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            100.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'></tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'></tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'></tr>
                                    </td>
                                )}
                                {type === 'GARENA' && (
                                    <td className='border'>
                                        {ratethe &&
                                            ratethe.map((item) => {
                                                if (item.telco === 'GARENA')
                                                    return (
                                                        <tr className='text-sm md:text-base min-h-[50px] border-b px-2 py-1 block'>
                                                            {Math.round(
                                                                (item.fees / (100 + Number(saleRate))) * 100 * 100,
                                                            ) / 100}
                                                            %
                                                        </tr>
                                                    )
                                                return null
                                            })}
                                        <tr className='text-sm md:text-base min-h-[50px] border-b px-2 py-1 block'></tr>
                                        <tr className='text-sm md:text-base min-h-[50px] border-b px-2 py-1 block'></tr>
                                        <tr className='text-sm md:text-base min-h-[50px] border-b px-2 py-1 block'></tr>
                                    </td>
                                )}
                                {type === 'GATE' && (
                                    <td className='border'>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            10.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            20.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            30.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            50.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            100.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            200.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            300.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            500.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            1000.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            2000.000 VNĐ
                                        </tr>
                                        <tr className='border-b px-2 py-1 block text-sm md:text-base min-h-[50px]'>
                                            5000.000 VNĐ
                                        </tr>
                                    </td>
                                )}
                                {type === 'GATE' && (
                                    <td className='border'>
                                        {ratethe &&
                                            ratethe.map((item) => {
                                                if (item.telco === 'GATE')
                                                    return (
                                                        <tr className='text-sm md:text-base min-h-[50px] border-b px-2 py-1 block'>
                                                            {Math.round(
                                                                (item.fees / (100 + Number(saleRate))) * 100 * 100,
                                                            ) / 100}
                                                            %
                                                        </tr>
                                                    )
                                                return null
                                            })}
                                    </td>
                                )}
                            </tr>
                        </table>
                    </div>
                </>
            )}
        </div>
    )
}

export default TableCard
